import * as React from 'react';
import { TicketReply } from '@journeyapps-platform/types-intercom';
import { MarkdownWidget } from '../../../widgets/MarkdownWidget';
import { styled } from '../../../theme';
import { DateTime } from 'luxon';
import Avatar from 'react-avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const img = require('../../../../media/support-agent-profile.png');

export interface TicketReplyWidgetProps {
  ticket: TicketReply;
  className?: any;
}

export const TicketReplyWidget: React.FC<TicketReplyWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      <S.Left>
        {props.ticket.user_agent ? (
          <S.AvatarImg src={img} />
        ) : (
          <S.AvatarCircle email={props.ticket.user_email} name={props.ticket.user_name} />
        )}
      </S.Left>
      <S.Right>
        <S.MetaContainer>
          <S.Author>{props.ticket.user_name}</S.Author>
          {props.ticket.user_agent ? <S.Agent>Agent</S.Agent> : null}
          <S.Relative>{DateTime.fromISO(props.ticket.created_at).toRelative()}</S.Relative>
        </S.MetaContainer>
        <S.Content agent={props.ticket.user_agent}>
          <MarkdownWidget content={{ text: props.ticket.comment }} />
          {props.ticket.attachments.length > 0 ? (
            <S.Attachments>
              {props.ticket.attachments.map((a) => {
                return (
                  <S.File key={a.id} href={a.url} download>
                    <S.FileName>{a.filename}</S.FileName>
                    <FontAwesomeIcon icon="download"></FontAwesomeIcon>
                  </S.File>
                );
              })}
            </S.Attachments>
          ) : null}
        </S.Content>
      </S.Right>
    </S.Container>
  );
};
namespace S {
  const widthAvatar = 50;

  export const Attachments = styled.div`
    display: flex;
    column-gap: 5px;
    margin-top: 10px;
  `;

  export const FileName = styled.div`
    padding-left: 5px;
    padding-right: 5px;
  `;

  export const File = styled.a`
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    color: white;
    padding: 4px;
    display: flex;
    align-items: center;
    text-decoration: none;
    column-gap: 5px;
  `;

  export const AvatarCircle = styled(Avatar)`
    max-height: ${widthAvatar}px;
    max-width: ${widthAvatar}px;
    border-radius: ${widthAvatar / 2}px;
  `;

  export const AvatarImg = styled.img`
    max-height: ${widthAvatar}px;
    max-width: ${widthAvatar}px;
    border-radius: ${widthAvatar / 2}px;
  `;

  export const Agent = styled.div`
    font-weight: bold;
    font-size: 12px;
    color: ${(p) => p.theme.text.secondary};
  `;

  export const Left = styled.div`
    flex-grow: 0;
  `;

  export const Right = styled.div`
    flex-grow: 1;
  `;

  export const Author = styled.div`
    font-weight: bold;
    color: ${(p) => p.theme.text.primary};
  `;

  export const Relative = styled.div`
    color: ${(p) => p.theme.text.secondary};
  `;

  export const MetaContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    column-gap: 10px;
  `;

  export const Content = styled.div<{ agent: boolean }>`
    margin-top: 10px;
    background: ${(p) =>
      p.agent ? p.theme.support.agent_comment_background : p.theme.support.user_comment_background};
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);

    img {
      max-width: 500px;
    }
  `;

  export const Container = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 10px;
  `;
}
